import {useEffect, useState} from 'react'
import {Button, Center, SelectItem} from '@mantine/core'
import {Modal} from 'react-bootstrap'
import {changeTextCapital, sortEmailsDescending} from '../../../_metronic/helpers/AssetHelpers'
import {setupAxios, useAuth} from '../../modules/auth'
import {
  cancelSubmit,
  deleteSalary,
  getSalary,
  getSalaryByEyeId,
  getSalaryById,
  handleInputChange,
  handleSubmit,
  validateForm,
} from './SalaryFunctions'
import {Toolbar1} from '../../../_metronic/layout/components/toolbar/Toolbar1'
import {getUsers} from '../../../api/AdminAPI'
import InputErrorBox from '../../components/InputErrorBox'
import axios from 'axios'
import {API_BASE_URL, EDIT_ROW_COLORS} from '../../../utils/contants'
import {getBandDataByUserId, getSalarysById} from '../../../api/SalaryAPI'

const Salary = () => {
  const [pay, setPay] = useState([
    {
      id: '',
      date: '',
      user: {
        firstName: '',
        lastName: '',
      },
      salaryStructureValues: [
        {
          basicValue: '',
          HRAValue: '',
          DAValue: '',
          educationValue: '',
          LTAValue: '',
          specialAllowanceValue: '',
          variableValue: '',
          telephoneAndInternetReimbursementValue: '',
          carAndDriverReimbursementValue: '',
          mealCouponValue: '',
          booksAndPeriodicalsValue: '',
          PFValue: '',
          PTValue: '',
          ESICValue: '',
          LWFValue: '',
        },
      ],
      band: {
        id: '',
        bandName: '',
        minCtc: '',
        maxCtc: '',
      },
      salaryType: '',
      salaryStructure: '',
      annualPackage: '',
    },
  ])

  const [editId, setEditId] = useState(null)
  const [inputError, setInputError] = useState<any>({})
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  const {currentUser} = useAuth()
  const isAdminUser = currentUser?.isAdmin || false
  const initialState = {
    date: '',
    user: '',
    salaryStructureValues: {
      basic: '',
      HRA: '',
      DA: '',
      education: '',
      LTA: '',
      specialAllowance: '',
      variable: '',
      telephoneAndInternetReimbursement: '',
      carAndDriverReimbursement: '',
      mealCoupon: '',
      booksAndPeriodicals: '',
      PF: '',
      PT: '',
      ESIC: '',
      LWF: ''
    },
    band: '',
    salaryType: 'yearly',
    salaryStructure: '',
    annualPackage: '',
  }
  const [inputField, setInputField] = useState(initialState)
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [users, setUsers] = useState<UserSal[]>([])
  const [salaryStructure, setSalaryStructure] = useState<any>(null)
  const [selectedStructure, setSelectedStructure] = useState<{
    salaryStructureName: string
    [key: string]: string | boolean | string[]
  } | null>(null)
  const [visibleFields, setVisibleFields] = useState<string[]>([])

  const [showDetails, setShowDetails] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)

  const handleEyeClick = async (item) => {
    try {
      const response = await getSalarysById(item.id)
      setSelectedUser(response.data)
      setShowDetails(true)
    } catch (error) {
      console.error('Error fetching salary details:', error)
    }
  }

  const [structure, setStructure] = useState<{label: string; value: string}[]>([])

  const fetchStructure = () => {
    const {token, tenantId} = setupAxios()
    axios
      .get(API_BASE_URL + `/salarystructure`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Tenant-Id': `${tenantId}`,
        },
      })
      .then((response: any) => {
        let salaryStructureData: {label: string; value: string}[] = []
        response.data.data.forEach((obj: {salaryStructureName: string; id: string}) => {
          salaryStructureData.push({
            label: obj.salaryStructureName,
            value: obj.id,
          })
        })
        setStructure(salaryStructureData)
        setSalaryStructure(response.data.data)
      })
      .catch((error) => {
        console.error('Error fetching salary structures:', error)
      })
  }

  const [configurationData, setConfigurationData] = useState<Configuration[]>([])

  const fetchConfigurationData = () => {
    const {token, tenantId} = setupAxios()
    axios
      .get<{data: Configuration[]}>(API_BASE_URL + `/configuration`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Tenant-Id': `${tenantId}`,
        },
      })
      .then((response) => {
        setConfigurationData(response.data.data)
      })
      .catch((error) => {
        console.error('Error fetching configuration data:', error)
      })
  }

  const [band, setBand] = useState<SelectItem[]>([])

  const fetchBand = () => {
    const {token, tenantId} = setupAxios()
    axios
      .get(API_BASE_URL + `/band`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Tenant-Id': `${tenantId}`,
        },
      })
      .then((response: any) => {

        let bandData: {label: string; value: string}[] = []
        response.data.data.map(
          (obj: {
            bandName: string
            bandDescription: string
            minCtc: string
            maxCtc: string
            id: string
          }) => {
            bandData.push({
              label: obj.bandName,
              value: obj.id,
            })
          }
        )
        setBand(bandData)
      })
      .catch((error) => {
        console.error('Error fetching bands:', error)
      })
  }

  useEffect(() => {
    let mounted = true
    if (mounted) {
      getSalary((fetchedEmails) => {
        const sortedEmails = sortEmailsDescending(fetchedEmails)
        setPay(sortedEmails)
        setAPIStatus({
          loading: false,
          error: null,
          submitLoading: false,
        })
      }, setAPIStatus)
      setIsAddUserModalOpen(false)
      setIsEditModalOpen(false)
      fetchStructure()
      fetchConfigurationData()
      fetchBand()

      getUsers()
        .then((userList: any) => {
          setUsers(userList.data)
        })
        .catch((error) => {
          console.error('Error fetching users:', error)
        })
    }
    return () => {
      mounted = false
    }
  }, [])

  const handleClose = () => {
    setIsAddUserModalOpen(false)
    setInputField(initialState)
    setInputError({})
    setEditId(null)
  }

  const handleUserSelect = (userId: string) => {
    const selectedUser = users.find((user) => user.id === userId)
    if (selectedUser) {
      setInputField({
        ...inputField,
        user: userId,
        band: selectedUser.band?.id || '',
      })
      handleUserBandSelect(userId)
    }
  }

  const handleSalaryStructureSelect = (structureId: string) => {
    const selected = salaryStructure.find((str: any) => str.id === structureId)
    if (selected) {
      setSelectedStructure(selected)
      const initialFields: any = {}
      const visibleFields: Set<string> = new Set()

      for (const key in selected) {
        if (selected[key] === true) {
          initialFields[key] = ''
          visibleFields.add(key)
        }
      }

      const annualPackageNumber = parseFloat(inputField.annualPackage)
      const calculatedFields = {...initialFields}

      // Calculate basic value first as other components depend on it
      const basicConfig = configurationData.find((config) => config.salaryComponentName === 'basic')
      if (basicConfig) {
        calculatedFields.basic = (annualPackageNumber * basicConfig.salaryComponentValue) / 100
      }

      visibleFields.forEach((field) => {
        const config = configurationData.find((config) => config.salaryComponentName === field)
        if (config) {
          switch (field) {
            case 'HRA':
              const da = calculatedFields.DA || 0
              calculatedFields.HRA =
                ((calculatedFields.basic + da) * config.salaryComponentValue) / 100
              break
            case 'DA':
            case 'ESIC':
              calculatedFields[field] = (annualPackageNumber * config.salaryComponentValue) / 100
              break
            case 'PF':
            case 'LTA':
              calculatedFields[field] = (calculatedFields.basic * config.salaryComponentValue) / 100
              break
            case 'education':
            case 'PT':
              calculatedFields[field] = config.salaryComponentValue
              break
            case 'mealCoupon':
              const mealCouponValue = parseFloat(
                inputField.salaryStructureValues.mealCoupon || '0'
              )
              calculatedFields[field] = (mealCouponValue * config.salaryComponentValue).toString()
              break
            default:
              if (config.salaryComponentUnit === '%') {
                calculatedFields[field] = (annualPackageNumber * config.salaryComponentValue) / 100
              } else if (config.salaryComponentUnit === 'monthly') {
                calculatedFields[field] = annualPackageNumber / 12
              }
          }
        }
      })

      // Calculate the sum of visible fields
      const sumOfFields = [
        'basic',
        'HRA',
        'DA',
        'education',
        'LTA',
        'variable',
        'mealCoupon',
        'booksAndPeriodicals',
        'PF',
        'PT',
        'ESIC',
        'LWF',
        'telephoneAndInternetReimbursement',
        'carAndDriverReimbursement',
      ].reduce((sum, field) => {
        return sum + (parseFloat(calculatedFields[field]) || 0)
      }, 0)

      // Calculate specialAllowance as the difference between annualPackage and sumOfFields
      const balance = annualPackageNumber - sumOfFields

      // Update specialAllowance field
      calculatedFields.specialAllowance = balance > 0 ? balance.toString() : ''

      // Update inputField state with calculatedFields and selected structure
      setInputField((prevInputField) => ({
        ...prevInputField,
        salaryStructureValues: calculatedFields,
        salaryStructure: structureId,
      }))

      // Ensure 'specialAllowance' is added only once to the visibleFields
      visibleFields.add('specialAllowance')
      setVisibleFields(Array.from(visibleFields))
    }
  }

  const changeTextCapital = (text: string): string => {
    return text.replace(/([A-Z])/g, ' $1').trim()
  }

  const [userBand, setUserBand] = useState<{minCtc: number; maxCtc: number} | null>(null)
  const [annualPackage, setAnnualPackage] = useState('')
  const [error, setError] = useState('')

  const handleUserBandSelect = async (userId: string) => {
    try {
      const userBandData = await getBandDataByUserId(userId)
      if (userBandData && userBandData.minCtc && userBandData.maxCtc) {
        setUserBand({
          minCtc: userBandData.minCtc,
          maxCtc: userBandData.maxCtc,
        })
      } else {
        setUserBand(null)
      }
    } catch (error) {
      console.error('Error fetching user band data:', error)
      setUserBand(null)
    }
  }

  const handleAnnualPackageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setAnnualPackage(value)
    setInputField((prevInputField) => ({
      ...prevInputField,
      annualPackage: value,
    }))
  }

  const handleAnnualPackageBlur = () => {
    const value = parseFloat(annualPackage)

    if (isNaN(value) || value <= 0) {
      setError('Invalid value or empty input.')
      return
    }

    if (userBand) {
      if (value < userBand.minCtc || value > userBand.maxCtc) {
        alert(`Annual Package should be between ${userBand.minCtc} and ${userBand.maxCtc}`)
      } else {
        setError('')
      }
    } else {
      setError('Please select a user to fetch band details.')
    }
  }

  return (
    <>
      <Toolbar1 />

      <Modal
        show={isAddUserModalOpen}
        onHide={() => setIsAddUserModalOpen(false)}
        animation={false}
        backdrop='static'
        centered
        size='lg'
      >
        <div className='modal-header'>
          <h2 className='fw-bolder'>Add Salary</h2>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => {
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              handleClose()
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row mb-4'>
            <div className='col-md-4'>
              <label className='fs-6 fw-semibold mb-2'>User Name</label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <select
                className='form-select'
                name='user'
                value={inputField.user}
                onChange={(event) => {
                  setInputField({...inputField, user: event.target.value})
                  handleUserSelect(event.target.value)
                }}
              >
                <option value=''>Select User</option>
                {Array.isArray(users) && users.length > 0 ? (
                  users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {`${user.firstName} ${user.lastName}`}
                    </option>
                  ))
                ) : (
                  <option value=''>No users available</option>
                )}
              </select>
              <InputErrorBox Message={inputError.user} />
            </div>
            <div className='col-md-4'>
              <label className='fs-6 fw-semibold mb-2'>Band</label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <input
                className='form-control'
                type='text'
                name='band'
                value={users.find((user) => user.id === inputField.user)?.band?.bandName || ''}
                onChange={(event) => handleInputChange(event, setInputField, inputField)}
                readOnly
              />
              <InputErrorBox Message={inputError.band} />
            </div>

            <div className='col-md-4'>
              <label className='fs-6 fw-semibold mb-2'>Date</label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <input
                className='form-control'
                type='date'
                name='date'
                value={inputField.date}
                onChange={(event) => handleInputChange(event, setInputField, inputField)}
              />
              <InputErrorBox Message={inputError.date} />
            </div>
          </div>
          <div className='row mb-4'>
            <div className='col-md-4'>
              <label className='required fw-bold fs-6 mb-2'>Salary Type:</label>
              <div className='d-flex mt-2'>
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='radio'
                    id='yearly'
                    name='salaryType'
                    value='yearly'
                    checked={inputField.salaryType === 'yearly'}
                    onChange={(event) => {
                      handleInputChange(event, setInputField, inputField)
                    }}
                  />
                  <label htmlFor='yearly' className='fw-bold text-gray-800 d-block me-3'>
                    Annual
                  </label>
                </div>

                <div className='form-check' style={{paddingRight: '20px'}}>
                  <input
                    className='form-check-input'
                    type='radio'
                    name='salaryType'
                    placeholder='radio1'
                    value='monthly'
                    id='monthly'
                    checked={inputField.salaryType === 'monthly'}
                    onChange={(event) => {
                      handleInputChange(event, setInputField, inputField)
                    }}
                  />

                  <label htmlFor='monthly' className=' fw-bold text-gray-800 d-block'>
                    Monthly
                  </label>
                </div>
              </div>
              <InputErrorBox Message={inputError.salaryType} />
            </div>

            <div className='col-md-4'>
              <label className='fs-6 fw-semibold mb-2'>
                {inputField.salaryType === 'monthly' ? 'Monthly Package' : 'Annual Package'}
              </label>
              <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
              <input
                type='number'
                className='form-control'
                id='annualPackage'
                name='annualPackage'
                value={inputField.annualPackage}
                // onChange={(e) => {
                //   handleInputChange(e, setInputField, inputField)
                // }}
                onChange={handleAnnualPackageChange}
                onBlur={handleAnnualPackageBlur}
              />
              {inputField.salaryType === 'monthly' && (
                <small className='text-muted'>
                  Equivalent Annual Package: {parseFloat(inputField.annualPackage) * 12}
                </small>
              )}
              <InputErrorBox Message={inputError.annualPackage} />
            </div>

            <div className='col-md-4'>
              <>
                <label className='fs-6 fw-semibold mb-2'>Salary Structure</label>
                <span className='text-danger ms-1 fs-4 fw-bold'>*</span>
                <select
                  className='form-select'
                  name='salaryStructure'
                  value={inputField.salaryStructure}
                  onChange={(event) => handleSalaryStructureSelect(event.target.value)}
                >
                  <option value=''>Select Structure</option>
                  {Array.isArray(structure) && structure.length > 0 ? (
                    structure.map((str) => (
                      <option key={str.value} value={str.value}>
                        {str.label}
                      </option>
                    ))
                  ) : (
                    <option value=''>No structures available</option>
                  )}
                </select>
                <InputErrorBox Message={inputError.salaryStructure} />
              </>
            </div>
          </div>
          {visibleFields.length > 0 && (
            <div className='row mb-4'>
              <h5 className='mb-4'>Salary Structure Component</h5>
              {visibleFields.map((field) => (
                <div key={field} className='col-md-4'>
                  <label htmlFor={field} className='fw-semibold fs-6 ms-2'>
                    {field === 'HRA' ||
                    field === 'DA' ||
                    field === 'LTA' ||
                    field === 'PF' ||
                    field === 'PT' ||
                    field === 'ESIC' ||
                    field === 'LWF'
                      ? field
                      : field.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}
                  </label>
                  <input
                    className='form-control'
                    type='text'
                    name={field}
                    value={inputField.salaryStructureValues[field] || ''}
                    onChange={(event) => {
                      const {name, value} = event.target
                      setInputField((prevInputField) => ({
                        ...prevInputField,
                        salaryStructureValues: {
                          ...prevInputField.salaryStructureValues,
                          [name]: value,
                        },
                      }))
                    }}
                  />
                  <InputErrorBox Message={inputError[field]} />
                </div>
              ))}
            </div>
          )}
        </div>
        <div className='modal-footer'>
          <button
            type='button'
            className='btn btn-secondary btn-sm'
            onClick={() => {
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              handleClose()
            }}
          >
            Cancel
          </button>
          <button
            className='btn btn-primary btn-sm ms-2'
            onClick={() => {
              handleSubmit(
                inputField,
                getSalary,
                setPay,
                setEditId,
                initialState,
                setInputField,
                editId,
                cancelSubmit,
                setAPIStatus,
                setInputError,
                validateForm,
                setSubmitAPIStatus,
                setIsAddUserModalOpen
              )
            }}
            disabled={SubmitAPIStatus.loading}
          >
            {SubmitAPIStatus.loading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </Modal>

      {/* //end of the form */}

      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          {/* begin:: card */}
          <div className='card card-xl-stretch mb-xl-8'>
            {/* begin:: card header */}
            <div className='card-header'>
              <div className='card-title'>Salarys</div>
              <div
                className='d-flex mt-4 justify-content-end'
                data-kt-user-table-toolbar='base'
                style={{height: '3rem'}}
              >
                {/* Begin::Add User button */}
                <button
                  type='button'
                  className='btn btn-sm btn-primary'
                  onClick={() => {
                    setIsAddUserModalOpen(true)
                    setInputField(initialState)
                    setInputError({})
                  }}
                >
                  Add Salary
                </button>
                {/* end::Add user button */}
              </div>
            </div>
            {/* begin:: card body */}
            <div className='card-body'>
              {APIStatus.submitLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : APIStatus.error != null ? (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{APIStatus.error}</div>
                </div>
              ) : (
                <div className='table-responsive  '>
                  <table
                    className='table 
              table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'
                  >
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '40px'}}>
                          {changeTextCapital('Sr.No')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '150px'}}>
                          {changeTextCapital('User Name')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '120px'}}>
                          {changeTextCapital('Salary Structure Name')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '150px'}}>
                          {changeTextCapital('Annual Package')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '120px'}}>
                          {changeTextCapital('Date')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '120px'}}>
                          {changeTextCapital('Actions')}
                        </th>
                      </tr>
                    </thead>

                    {pay?.length > 0 ? (
                      <tbody className='text-gray-800 fw-semibold text-left'>
                        {pay.map((obj: any, index: number) => (
                          <tr
                            className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}
                            key={obj?.id ?? '-'}
                          >
                            <td className='text-center'>{index + 1}</td>
                            <td className='flex-start'>
                              {obj?.user?.firstName ?? '-'} {obj?.user?.lastName ?? '-'}
                            </td>
                            <td className='text-center'>
                              {obj?.salaryStructure?.salaryStructureName ?? '-'}
                            </td>
                            <td className='text-end'>{obj?.annualPackage ?? '-'}</td>

                            <td className='text-end'>
                              {obj?.date
                                ? new Date(obj.date)
                                    .toLocaleDateString(undefined, {
                                      day: 'numeric',
                                      month: 'numeric',
                                      year: 'numeric',
                                    })
                                    .replace(/(\d+)\/(\d+)\/(\d+)/, '$2/$1/$3')
                                : '-'}
                            </td>
                            <td>
                              <div className='d-flex justify-content-center flex-shrink-0'>
                                {/* <button
                                  className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1'
                                  onClick={() => {
                                    document.getElementById('pay')?.focus()
                                    getSalaryByEyeId(
                                      obj.id,
                                      inputField,
                                      setInputField,
                                      setInputError
                                    )
                                    handleEyeClick(users)
                                    setIsAddUserModalOpen(true)
                                  }}
                                >
                                  <i className='far fa-eye'></i>
                                </button> */}
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1'
                                  onClick={() => {
                                    document.getElementById('pay')?.focus()
                                    getSalaryById(
                                      obj.id,
                                      inputField,
                                      setInputField,
                                      setEditId,
                                      setInputError
                                    )
                                    setIsEditModalOpen(true)
                                    setIsAddUserModalOpen(true)
                                  }}
                                >
                                  <i className='far fa-edit'></i>
                                </button>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                                  onClick={() =>
                                    deleteSalary(
                                      obj.id,
                                      getSalary,
                                      setPay,
                                      setAPIStatus,
                                      cancelSubmit,
                                      setInputField,
                                      initialState,
                                      setEditId,
                                      setInputError
                                    )
                                  }
                                >
                                  <i className='fa fa-trash'></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={5}>
                            <Center>No Record Available.</Center>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Salary
